import axios from "axios";
import { getAccessToken } from "./jwt-token-access/accessToken";

const API_URL = "";

const axiosApi = axios.create({
  baseURL: API_URL,
  timeout: 500000, // 30 segundos
});

axiosApi.interceptors.response.use(
  response => response,
  error => {
    // Tratamento de erros para problemas de conexão
    if (error.code === 'ECONNREFUSED' || error.code === 'ENOTFOUND' || error.code === 'ECONNRESET') {
      console.error('❌ Erro de conexão:', {
        message: 'Servidor não encontrado ou inacessível',
        url: error.config?.url,
        code: error.code
      });
      error.message = `Servidor não encontrado: ${error.config?.url}`;
    } else if (error.response?.status === 0) {
      console.error('❌ Erro de rede:', {
        message: 'Falha na requisição - servidor offline',
        url: error.config?.url,
        status: error.response?.status
      });
    } else if (error.response) {
      console.error('❌ Erro HTTP:', {
        status: error.response.status,
        statusText: error.response.statusText,
        url: error.config?.url,
        data: error.response.data
      });
    } else {
      console.error('❌ Erro desconhecido:', {
        message: error.message,
        url: error.config?.url
      });
    }
    return Promise.reject(error);
  }
);

async function setHeader() {
  const token = getAccessToken();
  // Só adiciona o header x-access-token se houver um token válido
  if (token && token.trim() !== "") {
    axiosApi.defaults.headers.common["x-access-token"] = token;
  } else {
    // Remove o header se não houver token
    delete axiosApi.defaults.headers.common["x-access-token"];
  }
  // Headers padrão para autenticação
}

export async function get(url, config = {}) {
  try {
    await setHeader();
    const response = await axiosApi.get(url, { ...config });
    // console.log("RESPOSTA_GET_UHULL", response.data);
    return response.data;
  } catch (error) {
    console.error("Erro ao fazer requisição GET:", error);
    throw error;
  }
}

export async function post(url, data, config = {}) {
  try {
    await setHeader();
    const response = await axiosApi.post(url, { ...data }, { ...config });
    return response.data;
  } catch (error) {
    console.error("Erro ao fazer requisição POST:", error);
    throw error;
  }
}

export async function put(url, data, config = {}) {
  try {
    await setHeader();
    const response = await axiosApi.put(url, { ...data }, { ...config });
    return response.data;
  } catch (error) {
    console.error("Erro ao fazer requisição PUT:", error);
    throw error;
  }
}

export async function del(url, config = {}) {
  try {
    await setHeader();
    const response = await axiosApi.delete(url, { ...config });
    return response.data;
  } catch (error) {
    console.error("Erro ao fazer requisição DELETE:", error);
    throw error;
  }
}

export async function patch(url, data, config = {}) {
  try {
    await setHeader();
    const response = await axiosApi.patch(url, { ...data }, { ...config });
    return response.data;
  } catch (error) {
    console.error("Erro ao fazer requisição PATCH:", error);
    throw error;
  }
}
